import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { CloseFilledOutlined } from "@mui-symbols-material/w300"
import React from "react"

import { Button } from "../common/Button"

import CommentsSection from "@/components/Comment/CommentsSection"
import type { CommentParentTableType } from "@/graphql/codegen/graphql"

interface CommentsListDialogProps {
  title: string
  commentParentTableType: CommentParentTableType
  referenceId: string
  onClose: () => void
}

export const CommentsListDialog: React.FC<CommentsListDialogProps> = ({
  title,
  commentParentTableType,
  referenceId,
  onClose,
}) => {
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        style: { height: "80vh", display: "flex", flexDirection: "column" },
      }}
    >
      <DialogTitle>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          {title && <Typography variant='h5'>{title}</Typography>}
          <Button size='small' appearance='text' onClick={onClose}>
            <CloseFilledOutlined className='text-blue-gray' />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <CommentsSection referenceId={referenceId} type={commentParentTableType} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
